import React, { useEffect } from 'react';
import propTypes from 'prop-types';

import { CardContent, MuiTitle } from 'src/ui/mui-ui-kit';;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getUser, fetchLoggedInUser } from 'src/user';
import { connect } from 'react-redux';

const processes = [
  { icon: ['fal', 'check-circle'], label: 'Complete Onboarding' },
  { icon: ['fal', 'user-check'], label: 'Background Verification' },
  { icon: ['fal', 'hourglass-half'], label: 'Await Approval' },
  { icon: ['fal', 'hand-holding-usd'], label: 'Active Banking' },
];

const employeeProcesses = [
  { icon: ['fal', 'check-circle'], label: 'Complete Onboarding' },
  { icon: ['fal', 'user-check'], label: 'Background Verification' },
  { icon: ['fal', 'hourglass-half'], label: 'Await Results' },
];

function StepProcess({ setNextEnabled, user }) {
  useEffect(() => {
    setNextEnabled(true);
  }, []);
  if (
    !user.hasFinishedOnboarding &&
    !user.isMerchantAdmin &&
    !user.isBankAdmin &&
    !user.isSuperAdmin
  ) {
    return (
      <CardContent className="step-process">
        <div className="content">
          <MuiTitle isSize="3" hasTextAlign="centered" hasTextColor="primary">
            How It Works
          </MuiTitle>
          <p className="has-text-grey-medium-dark has-text-centered leading">
            Once all information is gathered into the system. A background check
            will be initiated on your behalf and your account administrator will
            be notified of the results.
          </p>
        </div>
        <ul className="process-list">
          {employeeProcesses.map(item => (
            <li className="item has-text-info" key={item.label}>
              <span className="icon is-large has-icon-gradient-bright">
                <FontAwesomeIcon icon={item.icon} />
              </span>
              <span className="item-label">{item.label}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    );
  }
  if (!user.hasFinishedOnboarding && user.isMerchantAdmin) {
    return (
      <CardContent className="step-process">
        <div className="content">
          <MuiTitle isSize="3" hasTextAlign="centered" hasTextColor="primary">
            How It Works
          </MuiTitle>
          <p className="has-text-grey-medium-dark has-text-centered leading">
            Once all information is gathered into the system, our team will run
            due diligence to ensure that your account meets all legal and
            compliance requirements. An onboarding specialist will contact you
            to set up your banking services before activating your account.
          </p>
        </div>
        <ul className="process-list">
          {processes.map(item => (
            <li className="item has-text-info" key={item.label}>
              <span className="icon is-large has-icon-gradient-bright">
                <FontAwesomeIcon icon={item.icon} />
              </span>
              <span className="item-label">{item.label}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    );
  }
}

StepProcess.propTypes = {
  setNextEnabled: propTypes.func.isRequired,
  user: propTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    user: getUser(state),
  };
}

const connectedStepProcess = connect(mapStateToProps, {
  fetchLoggedInUser,
})(StepProcess);

export { connectedStepProcess as StepProcess };
